define((require) => {
    "use strict";

    const NavigationWidgetTargets = require("ui/editor/NavigationWidgetTargets").default;
    const WidgetTypes             = require("shared/ui/experience/widgets/WidgetTypes");
    const {WIDGET_TYPE_ICONS}     = require("shared/ui/experience/widgets/WidgetHelpers");

    function widgetNavigatesScenes(widget) {
        return widget.get("type") === "image" &&
            widget.get("action") &&
            widget.get("action").get("type") === "sceneNavigation" &&
            !widget.get("src");
    }

    function getWidgetMetaDataActions(widget) {
        const isLocked = {
            iconEnabled: "images/icons/unlocked-icon.svg",
            iconDisabled: "images/icons/locked-icon.svg",
            enabled: !widget.get("isLocked"),
            type: "lock",
            isActionDisabled: widget.get("isEditorHidden")
        };
        const isHidden = {
            iconEnabled: "images/icons/visible-icon.svg",
            iconDisabled: "images/icons/not-visible-icon.svg",
            enabled: !widget.get("isEditorHidden"),
            type: "hide",
            isActionDisabled: false
        };
        return [isLocked, isHidden];
    }

    function mapWidgetMetaData({widget, addActions = false}) {
        const isSceneNavigation = widgetNavigatesScenes(widget);
        const widgetType = isSceneNavigation ? widget.get("action").get("target") : widget.get("type");
        let widgetIcon;
        if (isSceneNavigation && (widgetType !== NavigationWidgetTargets.PREVIOUS_SCENE || widgetType !== NavigationWidgetTargets.NEXT_SCENE)) {
            widgetIcon = WidgetTypes.lookup("image").icon;
        } else {
            const iconName = isSceneNavigation ? `${widget.get("action").get("target")}-scene` : widget.get("type");
            widgetIcon = WidgetTypes.lookup(iconName).icon;
        }
        const widgetMetaData = {
            id: widget.get("uuid"),
            description: widget._getBasicDescription(),
            icon: WIDGET_TYPE_ICONS[widgetIcon]
        };

        if (addActions) {
            widgetMetaData.actions = getWidgetMetaDataActions(widget);
        }

        return widgetMetaData;
    }

    return {
        widgetNavigatesScenes,
        getWidgetMetaDataActions,
        mapWidgetMetaData
    };
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/SceneEditorHelpers.js